import axios from 'axios'
import alert from '../plugins/alert/alert'

// 根据环境切换接口地址
// axios.defaults.baseURL = process.env.BASE_API
axios.defaults.baseURL = `http://huachen.ihwasun.com`
// axios.defaults.headers = { 'X-Requested-With': 'XMLHttpRequest' }
axios.defaults.timeout = 10000

// 请求拦截器
axios.interceptors.request.use(
  config => {
    // 这里可以自定义一些config 配置
    // 判断登录状态
    return config
  }, error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
axios.interceptors.response.use(
  response => {
    return response.data
  }, error => {
    if (error.response !== undefined) {
      switch (error.response.status) {
        case '各错误状态':
          break
        default:
          alert.alertMethods.warn('好像发生错误了')
      }
      return Promise.resolve(error.response)
    }
    alert.alertMethods.warn('好像发生错误了')
    return Promise.resolve(error)
  }
)

export default {
  get (url, param) {
    if (param !== undefined) {
      Object.assign(param, {
        _t: (new Date()).getTime()
      })
    } else {
      param = {
        _t: (new Date().getTime())
      }
    }
    return new Promise((resolve, reject) => {
      axios({
        method: 'get',
        url,
        params: param
      }).then(res => {
        resolve(res)
      })
    })
  },
  post (url, param, config) {
    return new Promise((resolve, reject) => {
      axios.post(url, param, config).then(res => {
        resolve(res)
      })
    })
  },
  put: axios.put,
  _delete: axios.delete
}
